import { readable, writable } from 'svelte/store';

export const menu = writable(false);
// export const checkout = writable({});
export const customer = writable(undefined);
export const subscription = writable(undefined);
export const checkout = createCheckout();

function createCheckout() {
	const { subscribe, set, update } = writable({
        price_id: undefined,
        customer_id: undefined
    });

	return {
		subscribe,
        set,
		// increment: () => update(n => n + 1),
		// decrement: () => update(n => n - 1),
		reset: () => set({
            price_id: undefined,
            customer_id: undefined
        })
	};
}